import React from 'react';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';

import CarryImage from '../../../../images/plans/carry.png';
import HoldingHandsImage from '../../../../images/plans/holding_hands.png';
import { SERVICE_COLOR } from '../../styles/variables';
import PlanContext from '../context';
import PlanTermContext from './context';
import AccordionTimelineSeparator from './AccordionTimelineSeparator';
import AccordionTimeLineContent from './AccordionTimeLineContent';
import MeetingTimelineItem from './MeetingTimelineItem';
import Schedule from './Schedule';
import EditSchedule from '../../../admin/pages/Plan/containers/Schedule';
import Money from './Money';
import Dismissal from './Dismissal';
import MoneyDescription from './MoneyDescription';

const useStyles = makeStyles((theme) => ({
  timeline: {
    padding: 0,
    margin: 0,
  },
  missingOppositeContent: {
    '&:before': {
      display: 'none',
    },
  },
  timelineIcon: {
    width: 40,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: 50,
    },
  },
  schedule: {
    margin: theme.spacing(5, 0),
  },
  moneyContent: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(2),
    border: `0.5px solid ${SERVICE_COLOR}`,
  },
}));

const PlanTermTimeline = () => {
  const { component } = React.useContext(PlanContext);
  const { planTerm, isEditing } = React.useContext(PlanTermContext);

  const classes = useStyles();

  const { totalTimes, workingDays } = planTerm;
  // For the plans which published before meeting and dismissal setting added
  const isDismissalHidden =
    !isEditing && !(planTerm.dismissalPlace && planTerm.dismissalTime);
  const isMeetingHidden =
    !isEditing && !(planTerm.meetingPlace && planTerm.meetingTime);
  const isScheduleHidden = (planTerm.workingTimes || []).length === 0;

  return (
    <Timeline align="left" className={classes.timeline}>
      {isEditing && <MeetingTimelineItem isMeetingHidden={isMeetingHidden} />}
      <TimelineItem
        classes={{ missingOppositeContent: classes.missingOppositeContent }}
      >
        <AccordionTimelineSeparator hasConnector>
          <img
            src={CarryImage}
            className={classes.timelineIcon}
            alt={T.translate('planPage.planTerms.ongoing')}
          />
        </AccordionTimelineSeparator>
        <AccordionTimeLineContent
          title={T.translate('planPage.planTerms.ongoing')}
        >
          {!isScheduleHidden && !isEditing && <Schedule />}
          {isEditing && <EditSchedule />}
        </AccordionTimeLineContent>
      </TimelineItem>
      <TimelineItem
        classes={{ missingOppositeContent: classes.missingOppositeContent }}
      >
        <AccordionTimelineSeparator>
          <img
            src={HoldingHandsImage}
            className={classes.timelineIcon}
            alt={T.translate('planPage.planTerms.lastDay')}
          />
        </AccordionTimelineSeparator>
        <AccordionTimeLineContent
          title={T.translate('planPage.planTerms.lastDay')}
        >
          {!isDismissalHidden && <Dismissal />}
        </AccordionTimeLineContent>
      </TimelineItem>
      {/* src/admin/Plans/PlanTerm/Money.js */}
      <div className={classes.moneyContent}>
        {React.createElement(component?.money || Money)}
        <MoneyDescription totalTimes={totalTimes} workingDays={workingDays} />
      </div>
    </Timeline>
  );
};

export default PlanTermTimeline;
